import amwell from 'store/amwell/reducers';
import authentication, { authLite, tokenVerify } from 'store/authentication/reducers';
import booking from 'store/booking/reducers';
import billing from 'store/billing/reducers';
import consumerPreferences from 'store/consumerPreferences/reducers';
import cost from 'store/cost/reducers';
import fileUploads from 'store/fileUploads/reducers';
import findProvider from 'store/findProvider/reducers';
import providerSearch from 'store/providerSearch/reducers';
import connectCare from 'store/getCare/connectCare/reducers';
import liveCare from 'store/getCare/liveCare/reducers';
import global from 'store/global/reducers';
import goals from 'store/goals/reducers';
import myDoctors from 'store/myDoctors/reducers';
import messaging from 'store/messaging/reducers';
import network from 'store/network/reducers';
import notifications from 'store/notifications/reducers';
import profile from 'store/profile/reducers';
import triageGyant from 'store/triageGyant/reducers';
import payment from 'store/billing/Payment/reducers';
import appSettings from './appSettings/reducers';
import geolocation from './geolocation/reducers';
import account from './account/reducer';
import medications from './medications/reducers';
import visitSummary from './visitSummary/reducers';
import vitals from './vitals/reducers';
import immunizations from './medicalHistory/immunizations/reducers';
import allergies from './medicalHistory/allergies/reducers';
import procedures from './medicalHistory/procedures/reducers';
import problems from './medicalHistory/problems/reducers';
import socialHistory from './medicalHistory/socialHistory/reducers';
import events from './events/reducers';
import healthAdvisory from './healthAdvisory/reducers';
import audit from './audit/reducers';
import financialAssistance from './billing/financialAssistance/createApplication/reducers';
import testResults from './testResults/reducers';
import deepLink from './deepLink/reducers';
import glossary from './glossary/reducers';
import tooltips from './tooltips/reducers';
import medicalHistory from './medicalHistory/reducers';
import hipaaDocuments from './hipaaDocuments/reducers';
import bcsToken from './kyruus/kyruusProviderSearch/reducers';
import clinicNotes from './clinicNotes/reducers';
import preventativeCare from './preventativeCare/reducers';
import snacks from './snacks/reducers';
import navigation from './navigation/reducers';
import errors from './error/reducers';
import register from './register/reducers';
import covidScreening, { PrevPatientReducer as prevPatient } from './CovidScreening/reducers';
import healthRecords from './healthRecords/reducers';
import prediabetesVideos from './healthTools/reducers';
import eVisit from './eVisit/reducers';
import priorityItems from './priorityItems/reducers';
import patientEducation from './education/reducers';
import serviceNow from './serviceNow/reducers';

export default {
  account,
  allergies,
  amwell,
  appSettings,
  audit,
  authentication,
  authLite,
  billing,
  booking,
  bcsToken,
  clinicNotes,
  connectCare,
  consumerPreferences,
  cost,
  covidScreening,
  deepLink,
  errors,
  events,
  eVisit,
  fileUploads,
  financialAssistance,
  findProvider,
  geolocation,
  global,
  glossary,
  goals,
  healthRecords,
  healthAdvisory,
  hipaaDocuments,
  immunizations,
  liveCare,
  medicalHistory,
  medications,
  messaging,
  myDoctors,
  navigation,
  network,
  notifications,
  patientEducation,
  payment,
  preventativeCare,
  prediabetesVideos,
  priorityItems,
  problems,
  procedures,
  profile,
  providerSearch,
  register,
  serviceNow,
  snacks,
  socialHistory,
  testResults,
  tokenVerify,
  tooltips,
  triageGyant,
  visitSummary,
  vitals,
  prevPatient
};
